// Creator Studio lives on studio.afterhourz.tv, as its own app (studio/). The main site's
// router is hash-based, so its "Creator Studio" link and any old #/studio/… bookmark end up
// here: they move to the studio host, and old upload links open the New Post tab.
//   afterhourz.tv/#/studio/upload  → studio.afterhourz.tv/#/new
//   afterhourz.tv/#/studio/…       → studio.afterhourz.tv/
// Sign-in carries over through the shared *.afterhourz.tv session cookies.

const MAIN_HOST = 'afterhourz.tv';
const STUDIO_HOST = 'studio.afterhourz.tv';

const hashPath = () => location.hash.replace(/^#/, '') || '/';
const isStudioPath = (p: string) => p === '/studio' || p.startsWith('/studio/') || p.startsWith('/studio?');
const origin = (host: string) => `${location.protocol}//${host}${location.port ? `:${location.port}` : ''}`;

export function routeStudioHost() {
  const host = location.hostname;
  if (host !== MAIN_HOST && host !== `www.${MAIN_HOST}`) return; // the studio is its own app; localhost/previews stay put
  if (location.pathname !== '/' && location.pathname !== '/index.html') return;

  const check = () => {
    const path = hashPath();
    if (isStudioPath(path)) location.replace(`${origin(STUDIO_HOST)}/${path.startsWith('/studio/upload') ? '#/new' : ''}`);
  };
  check();
  addEventListener('hashchange', check);
}
